import axios from "axios";

import { GetUserAssetsResponse } from "@syla/shared/types/responses/GetUserAssetsResponse";
import { TransportType } from "@syla/shared/types/helpers/TransportType";

export const getUserAssets = async (): Promise<
  TransportType<GetUserAssetsResponse<string>>
> => {
  const { data } = await axios.get("/assets/user");
  return data;
};
